import script from "./PrivateReleaseInvitations.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateReleaseInvitations.vue?vue&type=script&setup=true&lang=js"

import "./PrivateReleaseInvitations.vue?vue&type=style&index=0&id=4ef4853c&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef4853c"]])

export default __exports__